const config = {
  BucketName: "football-app-audio-bucket",
  sessionBucketName: "kicks-adhoc-session-requests",
  region: "us-east-2",
  userPoolId: "us-east-2_9HSgEtgrA", // Your User Pool ID
  userPoolWebClientId: "1vsclecai0qja70ofqo8hu5vlg", // Your App Client ID
  identityPoolId: "us-east-2:8bf044a9-8520-4819-9417-3f453015e7fd", // Your Identity Pool ID
  IS_DEV: false, // or false
};

export default config;
